async function t(t){try{return await t}catch{}}export{t as attempt};
